
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Les différences entre campagnes Search, Display et Shopping sur Google Ads",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez les différences entre campagnes Search, Display et Shopping sur Google Ads et apprenez à choisir la bonne stratégie pour booster vos performances avec ALEO.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Les différences entre campagnes Search, Display et Shopping sur Google Ads",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez les différences entre campagnes Search, Display et Shopping sur Google Ads et apprenez à choisir la bonne stratégie pour booster vos performances avec ALEO.",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-apropos.jpg"),
        // },
      ],
    };
  },
};
